(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var template = '<article><a href="${link}" class="img--zoom" target="_blank"><img src="${img}"></a><h2 class="heading--4"><a href="${link}" target="_blank">${title}</a></h2></article>';

	$('[data-external-posts]').each(function () {
		var el = $(this);
		var config = el.attr('data-external-posts');
		var html = '';

		config = JSON.parse(config);

		if (config.domain) {
			var endpoint = config.domain + '/wp-json/wp/v2/';
			var postType = config.post_type || 'posts';
			var category = config.category || null;
			var limit = config.limit || 3;

			var query = '?_embed&per_page=' + limit + '&page=' + 1 + '&';

			if (category) {
				if (postType == 'posts') {
					query += ('categories=' + category);
				}
				else {
					query += (postType + '_category=' + category);
				}
			}

			$.ajax({
				cache: false,
				url: endpoint + postType + query,
				dataType: "json",
				success: function (data) {
					if (data && data.length) {
						$(data).each(function (key, post) {
							var article = template;

							article = article.replace(/\${link}/g, post.link);
							article = article.replace(/\${title}/g, post.title.rendered);

							if (post._embedded &&
								post._embedded['wp:featuredmedia'] &&
								post._embedded['wp:featuredmedia'].length &&
								post._embedded['wp:featuredmedia'][0].media_details &&
								post._embedded['wp:featuredmedia'][0].media_details.sizes &&
								post._embedded['wp:featuredmedia'][0].media_details.sizes['sleek-medium'] &&
								post._embedded['wp:featuredmedia'][0].media_details.sizes['sleek-medium'].source_url) {
								article = article.replace(/\${img}/g, post._embedded['wp:featuredmedia'][0].media_details.sizes['sleek-medium'].source_url);
							}

							html += article;
						});

						el.html(html);
					}
					else {
						el.remove();
					}
				}
			});
		}
	});
})();
